import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ListChecks, Send, Rocket } from "lucide-react";

const HowItWorksSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const steps = [
    { icon: ListChecks, num: "01", title: "Escolha o plano", desc: "Selecione o plano ideal para o seu negócio." },
    { icon: Send, num: "02", title: "Envie informações básicas", desc: "Textos, logo e fotos. Nós cuidamos do resto." },
    { icon: Rocket, num: "03", title: "Receba sua página pronta", desc: "Em até 72 horas sua página estará no ar." },
  ];

  return (
    <section className="py-24 md:py-32 relative" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <span className="text-sm font-mono text-secondary uppercase tracking-widest">Como funciona</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4">
            Simples como <span className="gradient-text-blue">1, 2, 3.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.2 + i * 0.15 }}
              className="glass-card rounded-2xl p-8 text-center relative group hover:border-primary/30 transition-colors"
            >
              <span className="text-6xl font-bold text-primary/10 absolute top-4 right-6 group-hover:text-primary/20 transition-colors">{step.num}</span>
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary/20 transition-colors">
                <step.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-bold text-lg mb-2">{step.title}</h3>
              <p className="text-sm text-muted-foreground">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
